import { Review } from "@/services/bedrock/dtos/Review";

function time(value: string | null): number {
  const parsed = value ? Date.parse(value) : NaN;
  return Number.isNaN(parsed) ? -Infinity : parsed;
}

/**
 * The `count` most shareable review ids not in `exclude`. The postable list arrives newest first,
 * so it is ranked here: by score (unscored last), then by date, newest first.
 */
export function pickBestReviews(reviews: Review[], count: number, exclude: number[]): number[] {
  if (count <= 0) return [];
  const excluded = new Set(exclude.map(Number));
  return [...reviews]
    .sort((a, b) => {
      const scoreA = a.aiShareabilityScore ?? -Infinity;
      const scoreB = b.aiShareabilityScore ?? -Infinity;
      if (scoreA !== scoreB) return scoreB - scoreA;
      return time(b.effectiveDate) - time(a.effectiveDate);
    })
    .map(review => Number(review.id))
    .filter(id => !excluded.has(id))
    .slice(0, count);
}
